<template>
  <div class="wrap">
    <div class="text">孩慧营商家暂不支持PC工作台，请前往手机应用市场或扫描下方二维码下载孩子王商家移动端APP：“商客合一”进行操作，APP登录账号同PC端账号一致</div>
    <div class="qrcodeWrap">
      <div class="qrcode" v-for="qrcode in this.qrcodes" :key="qrcode.value">
        <img :src="qrcode.qrcode" alt="">
        <div class="label">{{qrcode.label}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import iosQrcode from '../../assets/images/advertiser/qrcode-ios.png'
import androidQrcode from '../../assets/images/advertiser/qrcode-android.png'
export default {
  data() {
    return {
      qrcodes: [
        {
          value: 1,
          label: '安卓下载',
          qrcode: androidQrcode,
        },
        {
          value: 2,
          label: 'IOS下载',
          qrcode: iosQrcode,
        },
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .text {
    margin-top: 120px;
    flex: none;
    width: 1000px;
    font-size: 28px;
    color: #333;
    font-weight: bold;
    line-height: 48px;
  }
  .qrcodeWrap {
    margin-top: 80px;
    flex: none;
    width: 1000px;
    display: flex;
    justify-content: flex-end;
    .qrcode {
      width: 200px;
      height: 280px;
      img {
        width: 200px;
        height: 200px;
      }
      .label {
        margin-top: 20px;
        width: 200px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 22px;
        color: #666;
      }
      &:last-child {
        margin-left: 80px;
      }
    }
  }
}
</style>
